import { connect } from 'react-redux'
import { compose } from 'redux'
import { push } from 'connected-react-router'
import toJS from '../../../hoc/toJS'
import PageSocialMedia from '../present/PageSocialMedia'
import actionTypes from '../../../actions/actionTypes'
import { SOCIAL_MEDIA_DATA } from '../../../constants/state'
import config from '../../../config.json'

const mapStateToProps = state => ({
    presets:   state.getIn([SOCIAL_MEDIA_DATA, 'presets']),
    isLoading: state.getIn([SOCIAL_MEDIA_DATA, 'isLoading']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onEdit: (presetId) => {
        const cinemaId = ownProps.match.params.cinemaId
        dispatch(push(`${config.routes.socialMedia.path}/${cinemaId}/preset/${presetId}`))
    },
    onCreateNew: () => {
        const cinemaId = ownProps.match.params.cinemaId
        dispatch(push(`${config.routes.socialMedia.path}/${cinemaId}/new`))
    },
    onGeneratePost: (presetId) => {
        const cinemaId = ownProps.match.params.cinemaId
        dispatch(push(`${config.routes.socialMedia.path}/${cinemaId}/post/${presetId}`))
    },
    onDuplicate: (preset) => {
        const duplicate = Object.assign({}, preset, { name: preset.name + ' (Kopie)', id: undefined })
        dispatch({ type: actionTypes.SOCIAL_MEDIA_PRESET_CREATE_REQUEST, payload: duplicate })
    },
    onDelete: (presetId) => {
        dispatch({ type: actionTypes.SOCIAL_MEDIA_PRESET_DELETE_REQUEST, payload: { id: presetId } })
    },
})

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PageSocialMedia)
